import React from 'react';
import clsx from 'clsx';
import kebabCase from 'lodash/kebabCase';
import Tag from 'core/components/Tag';
import {
  Illness,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/types/visitNote';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from 'core/icons/delete';
import ToolTip from 'core/components/Tooltip';
import {
  useFormContext,
  useWatch,
} from 'react-hook-form';

export default function HPIList() {
  const { control, setValue } = useFormContext();
  const hpiFromIntakeElements = useWatch({
    control,
    name: 'hpi.hpiFromIntakeElements',
  }) ?? [];

  const onRemove = (index: number) => {
    setValue('hpi.hpiFromIntakeElements', [
      ...hpiFromIntakeElements.slice(0, index),
      ...hpiFromIntakeElements.slice(index + 1),
    ]);
  };

  return (
    <ul className={clsx({ '!mt-0 !-mb-2': hpiFromIntakeElements.length === 0 })}>
      {hpiFromIntakeElements?.map(({ title, hpiAttributes }: Illness, index: number) => (
        <li
          key={kebabCase(title)}
          className="gap-1 text-xs flex items-start w-full"
        >
          <ToolTip title="Remove">
            <IconButton
              size="small"
              color="error"
              onClick={() => { onRemove?.(index); }}
            >
              <DeleteIcon className="!w-5 !h-5 text-gray-700" />
            </IconButton>
          </ToolTip>
          <span className="font-semibold py-2">
            {title}
            :
          </span>
          <div className="flex flex-wrap flex-1 gap-1 items-start justify-start py-1.5">
            {hpiAttributes.map((item: string) => (
              <Tag
                key={item}
                className="font-semibold"
                tagName="common"
              >
                {item}
              </Tag>
            ))}
          </div>
        </li>
      ))}
    </ul>
  );
}
